// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"05ead940","191":"3cdd312f","793":"ea6347bd","925":"0693a156"}[chunkId] + ".chunk.js";
};